<template>
  <div>
    <v-card :outlined="isPdf ? false : true" :height="isPdf ? null : 400">
      <v-card-title>Event Program</v-card-title>
      <v-card-subtitle class="d-flex justify-space-between align-center" v-if="!isPdf">
        <div class="d-flex">
          <img
              :src="getImage('subevent-icon')"
              width="18"
              contain
              class="mr-2"
          />
          <span>{{ linkedSubEvents.length }} agendas</span>
        </div>
        <div class="d-flex">
          <img
              :src="getImage('session-icon')"
              width="18"
              contain
              class="mr-2"
          />
          <span>{{ linkedSessions.length }} sessions</span>
        </div>
        <div class="d-flex">
          <img
              :src="getImage('speaker-icon')"
              width="18"
              contain
              class="mr-2"
          />
          <span>{{ noOfSpeakers }} speakers</span>
          <v-tooltip  bottom max-width="500">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" class="ml-5" size="18" color="#96A4B9">
                mdi-information-outline
              </v-icon>
            </template>
            <span>This speaker count reflects the total number of unique speakers.</span>
          </v-tooltip>
        </div>
      </v-card-subtitle>
      <v-card-subtitle v-else class="d-flex justify-space-between align-center pt-4">
        <v-row>

          <v-col cols="2" class="d-flex">
            <img
                :src="getImage('subevent-icon')"
                width="18"
                contain
                class="mr-2"
            />
            <span>{{ linkedSubEvents.length }} agendas</span>
          </v-col>
          <v-col cols="2" class="d-flex">
            <img
                :src="getImage('session-icon')"
                width="18"
                contain
                class="mr-2"
            />
            <span>{{ linkedSessions.length }} sessions</span>
          </v-col>
          <v-col cols="2" class="d-flex">
            <img
                :src="getImage('speaker-icon')"
                width="18"
                contain
                class="mr-2"
            />
            <span>{{ noOfSpeakers }} speakers</span>
          </v-col>
        </v-row>

      </v-card-subtitle>
      <v-divider></v-divider>
      <v-card-text class="pa-0 grey lighten-5">
        <v-data-table
            :headers="headers"
            :items="sortedSubEvents"
            hide-default-footer
            disable-pagination
            style="max-height: 100%; overflow-y: auto;"
        >
          <template v-slot:item.name="{ item }">
            <div>{{ item.name }}</div>
          </template>
          <template v-slot:item.sessions="{ item }">
            {{ getNoOfSessions(item) }}
          </template>
          <template v-slot:item.speakers="{ item }">
            {{ getNoOfSpeakers(item) }}
          </template>
          <template v-slot:item.contentFeed="{ item }">
            {{ getNoOfContentFeed(item) }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import SetupAnalyticContainer from "./SetupAnalyticContainer";
import ViewClickDetailsDialog from "./ViewClickDetailsDialog";

export default {
  components: {
    SetupAnalyticContainer,
    ViewClickDetailsDialog,
  },
  computed: {
    ...mapGetters(["currentEvent", "linkedSubEvents", "linkedSessions"]),
    noOfSpeakers() {
      return this.currentEvent.speakers.length || "-";
    },
    sortedSubEvents() {
      return this.linkedSubEvents.slice().sort(function (a, b) {
        return new Date(a.startDateTime) - new Date(b.startDateTime);
      });
    },
  },
  props: {
    isPdf: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      showClickDetailsDialog: false,
      selectedSponsorAnalytic: null,
      contentFeeds: [],
      headers: [
        {
          text: "Agenda name",
          value: "name",
          align: "start",
        },
        {
          text: "# of sessions",
          value: "sessions",
          align: "start",
        },
        {
          text: "# of speakers",
          value: "speakers",
          align: "start",
        },
        {
          text: "# of content feeds",
          value: "contentFeed",
          align: "start",
        },
      ],
    };
  },
  methods: {
    getImage(image) {
      if (this.isPdf) {
        return require("@/assets/icons/" + image + ".png");
      } else {
        return require("@/assets/icons/" + image + ".svg");
      }
    },
    getClickCount(sponsorAnalytic) {
      let count = 0;
      sponsorAnalytic.clickData.forEach((item) => {
        count += item.clickCount;
      });
      return count;
    },
    viewClickCount(sponsorAnalytic) {
      this.showClickDetailsDialog = true;
      this.selectedSponsorAnalytic = sponsorAnalytic;
    },
    getNoOfSessions(subEvent) {
      if (subEvent.linkedSessions.length == 0) return "-";
      else
        return subEvent.linkedSessions.length;
    },
    getNoOfSpeakers(subEvent) {
      let speakers = this.currentEvent.speakers.filter(
          (speaker) => {
            return (
                speaker.associatedSpeakerSessions.length > 0 &&
                speaker.associatedSpeakerSessions.some(sessionId => subEvent.linkedSessions.includes(sessionId)))
          }
      );
      return speakers.length;
    },
    getNoOfContentFeed(subEvent) {
      if (subEvent.linkedSessions.length == 0) return "0";
      const sessions = this.linkedSessions.filter((session) =>
          subEvent.linkedSessions.includes(session.id)
      );
      return sessions.filter((e) => e.enableContentFeed).length;
    }
  },
};
</script>

<style>
</style>